import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { IconArrowRight } from "@tabler/icons-react";
import { cn } from "@/shared/lib/utils";
import { ymReachGoal } from "@/shared/lib/yandexMetrika";
import { scrollHostToAnchor, useLandingScrollHost } from "./scrollHost";
import styles from "./Landing.module.scss";
/** Куда ведут все CTA «создать песню» (пока — единая страница создания). */
export const CREATE_PATH = "/generate-song";
/** Путь текущего лендинга — для метки placement в цели Метрики. */
export const LandingPathContext = React.createContext("");
/**
 * Прокрутка к секции страницы. Скроллит либо документ (лендинг вне app-shell),
 * либо контейнер шелла — какой именно, знает LandingScrollHostContext.
 */
export const scrollToAnchor = (id, host) => (e) => {
    if (!document.getElementById(id))
        return;
    e.preventDefault();
    scrollHostToAnchor(host, id);
};
/**
 * Кнопка лендинга. CTA «создать песню» — настоящая ссылка (`<a href>` через
 * Link) на /generate-song с ТЕКУЩИМ query: utm-метки, click_id, yclid доезжают до
 * страницы создания, а attributionUtm подхватывает их там же, где и с любой
 * другой входной точки. Ссылка, а не onClick-navigate — чтобы робот видел
 * переход, а человек мог открыть его в новой вкладке.
 */
export const CtaButton = ({ cta, placement, variant = "primary", size = "lg", className, arrow = true, }) => {
    const location = useLocation();
    const landingPath = React.useContext(LandingPathContext);
    const scrollHost = useLandingScrollHost();
    const cls = cn(styles.btn, styles[`btn_${variant}`], styles[`btn_${size}`], className);
    if (cta.anchor) {
        return (_jsx("a", { href: `#${cta.anchor}`, className: cls, onClick: scrollToAnchor(cta.anchor, scrollHost), children: _jsx("span", { children: cta.label }) }));
    }
    if (cta.to) {
        return (_jsx(Link, { to: cta.to, className: cls, children: _jsx("span", { children: cta.label }) }));
    }
    return (_jsxs(Link, { to: { pathname: CREATE_PATH, search: location.search }, className: cls, onClick: () => ymReachGoal("cta_click", { placement: `landing${landingPath}:${placement}` }), children: [_jsx("span", { children: cta.label }), arrow && _jsx(IconArrowRight, { size: 18, stroke: 2, className: styles.btnArrow, "aria-hidden": "true" })] }));
};
